// extracted by mini-css-extract-plugin
export default {"header":"header_header__z8ezc","logo":"header_logo__wLirW","title":"header_title__j5wSX","logout":"header_logout__7cAFW"};